/**
 * Created by ys on 2018/4/3.
 */
const getters = {
  certification:state => state.user.certification,

  sidebar: state => state.sys.sidebar,
  permission_routers: state =>state.sys.routers,
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js